// src/components/AboutUs.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutUs.css';
import logo from '../assets/logo.png';
import whatsapp from '../assets/WhatsApp.svg.webp';

const AboutUs = () => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate('/counselling');
  };

  const handleJoinCommunity = (e) => {
    e.stopPropagation();
    window.open('https://whatsapp.com/channel/0029VbCxJ3r3wtbIi0g7dg0W', '_blank');
  };

  return (
    <div className="about-us-section">
      <h2>About Us</h2>

      <div className="about-container">
        {/* CARD 1 – About Shooin Stars */}
        <div className="about-card" onClick={handleRedirect}>
          <img src={logo} alt="Shooin Stars Logo" className="about-logo" />

          <h3 className="about-title">SHOOIN STARS</h3>

          <p className="about-description">
            Shooin Stars Admission Counseling is a leading admission counseling firm
            in Maharashtra. Shooin Stars has immense technical{' '}
            <a href="counselling" onClick={(e) => e.stopPropagation()}>
              Read more
            </a>
          </p>

          <div className="about-stats">
            <div>
              <span className="about-number">8000+</span>
              <div className="about-label">Admitted</div>
            </div>
            <div>
              <span className="about-number">4000+</span>
              <div className="about-label">Trained</div>
            </div>
          </div>

          <button className="whatsapp-button" onClick={handleJoinCommunity}>
            <img src={whatsapp} alt="WhatsApp" className="whatsapp-icon" />
            Join our Channel
          </button>
        </div>

        {/* CARD 2 – Download App */}
        <div className="about-card app-card">
          <h3 className="about-title">Download Our App</h3>

          <p className="about-description">
            Get instant admission updates, counseling support, and personalized
            guidance directly on your mobile.
          </p>

          <a
            href="https://play.google.com/store/apps/details?id=com.vaidilya.collegeconnect"
            target="_blank"
            rel="noopener noreferrer"
            className="playstore-link"
          >
            <img
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              alt="Get it on Google Play"
              className="playstore-badge"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;